/* eslint-disable */
export default {
  attachFiles: 'Allega file',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
